module.exports = __webpack_public_path__ + "img/img_36@2x.6f25b7a1.png";